import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InitWrapper from './InitWrapper';
import { goToRolesAndPermissions, goToSettings } from '../../stateManagement/engine/actions/SessionActions';

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onSettingsClick: goToSettings,
      onRolesAndPermissionsClick: goToRolesAndPermissions,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(InitWrapper);
